import CampaignForm from './CampaignForm';

export default CampaignForm;




// WEBPACK FOOTER //
// ./src/views/CampaignForm/index.js